export default __webpack_public_path__ + "static/15-c44981aef9196ab9e20bb044d277fdf7.jpg";